import { render, staticRenderFns } from "./MailRecord.vue?vue&type=template&id=12d9c056"
import script from "./MailRecord.vue?vue&type=script&lang=js"
export * from "./MailRecord.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\BuildAgent\\work\\136\\s\\Yahome.RecruitSystem.Web\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('12d9c056')) {
      api.createRecord('12d9c056', component.options)
    } else {
      api.reload('12d9c056', component.options)
    }
    module.hot.accept("./MailRecord.vue?vue&type=template&id=12d9c056", function () {
      api.rerender('12d9c056', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/back/SystemManage/MailRecord.vue"
export default component.exports